import WaldoficationSimplifiedUpsell from './WaldoficationSimplifiedUpsell';
import WaldoficationSimplifiedUpsellModal, {
  WALDOFICATION_SIMPLIFIED_UPSELL_MODAL,
} from './modal';

export {
  WaldoficationSimplifiedUpsellModal,
  WALDOFICATION_SIMPLIFIED_UPSELL_MODAL,
};

export default WaldoficationSimplifiedUpsell;
